// pages/Dashboard.js
import React from "react";
import ThemeToggle from "../../components/buttons/ThemeToggle";

const Dashboard = () => {
  return (
    <div style={{ position: "relative", height: "100vh" }}>
      <div style={{ position: "absolute", top: 10, right: 10 }}>
        <ThemeToggle />
      </div>
      <div
        style={{
          display: "grid",
          placeContent: "center",
          height: "100%",
        }}
      >
        <p>No Data for Dashboard yet!</p>
      </div>
    </div>
  );
};

export default Dashboard;